module.exports = __webpack_public_path__ + "static/media/pipecandy.c3f1af81.png";